import React from 'react';
import {APP_NO_IMG} from "../../../const/root";

interface Props {
    src: string

}

export class ImgProduct extends React.Component<Props, {}> {
    // @ts-ignore
    addDefaultSrc = ev => {
        ev.target.src = APP_NO_IMG;
    }


    render() {

        let src: string = this.props.src
        const isMobile = window.innerWidth < 768;

        const frameStyle: React.CSSProperties = {
            width: 100,
            height: 100,
            borderRadius: 10,
            overflow: "hidden",
            // backgroundColor: "#F5F8FC",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 6
        };

        return (
          <div style={{maxWidth: 100, padding: 10, display: "flex", justifyContent: "center"}}>
                <div style={frameStyle}>
                    <img
                        style={{width: "100%", height: "100%", objectFit: "contain", objectPosition: "center"}}
                        src={src}
                        onError={this.addDefaultSrc}
                        alt="good.png"/>
                </div>
            </div>


        )
    }
}

